import { spacing } from '@rbilabs/universal-components/themes';
import { StyleSheet, View } from 'react-native';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import { Skeleton } from 'components/ui/skeleton';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { LoyaltySkeletonHeader } from 'pages/loyalty/loyalty-skeleton/loyalty-skeleton-header';

import { LoyaltySkeletonRewardCard } from './loyalty-skeleton-reward-card';

export const LoyaltyRewardsSkeletonLoader = () => {
  const isDesktop = useIsDesktopBreakpoint();
  const numOfCategories = 7;
  const numOfCards = isDesktop ? 10 : 3;

  return (
    <View>
      <CenteredRowContainer style={{ paddingHorizontal: isDesktop ? spacing.$72 : spacing.$4 }}>
        <LoyaltySkeletonHeader />
      </CenteredRowContainer>

      <CenteredRowContainer style={{ paddingLeft: spacing.$4 }}>
        <View style={[styles.container]}>
          <View style={styles.categories}>
            {Array.from({ length: numOfCategories }).map((_, categoryIndex) => (
              <View key={categoryIndex} style={{ height: 250 }}>
                <Skeleton shape="rectangle" style={{ width: 71, height: 18 }} />

                <View style={styles.cards}>
                  {Array.from({ length: numOfCards }).map((_, cardIndex) => (
                    <LoyaltySkeletonRewardCard key={`card-${categoryIndex}-${cardIndex}`} />
                  ))}
                </View>
              </View>
            ))}
          </View>
        </View>
      </CenteredRowContainer>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  categories: {
    marginTop: spacing.$4,
  },
  cards: {
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
    gap: 10,
    marginBottom: spacing.$4,
    height: 200,
  },
});
